import { Component, Input, ViewChild } from '@angular/core';
import { Field } from 'shared';
import { FieldCropsGridComponent } from '../field-crops-grid/field-crops-grid.component';

@Component({
  selector: 'app-field-crops-popup',
  templateUrl: './field-crops-popup.component.html',
  styleUrls: ['./field-crops-popup.component.scss']
})

export class FieldCropsPopupComponent {
  @Input()
  field?: Field;

  visible: boolean;

  @ViewChild(FieldCropsGridComponent, { static: false })
  grid: FieldCropsGridComponent;
  title: string;

  constructor() {
  }

  showFieldCrops(field: Field) {
    this.field = field;
    this.title = 'Liste des cultures ' + field.name;

    this.onShown();

    this.visible = true;
  }

  onShown() {
    setTimeout(_ => {
      this.grid.showFieldCrops(this.field);
    }, 50);
  }
}
